import { Typography } from "@fullscript/aviary-web";
import { useTranslation } from "react-i18next";

import { l } from "@unauthenticated/shared/locales/i18n";

import * as styles from "./QualityProgramSlide.styles";

// TODO: placeholder content — final copy and visuals land with the quality-story slide ticket.
const QualityProgramSlide = () => {
  const { t } = useTranslation();

  return (
    <div css={styles.slide}>
      <Typography variant="h3" intention="inverse" isMarginless>
        {t(l.sideCarousel.slides.qualityProgram.title)}
      </Typography>
      <Typography intention="inverse" isMarginless>
        {t(l.sideCarousel.slides.qualityProgram.body)}
      </Typography>
    </div>
  );
};

export { QualityProgramSlide };
